/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_Url_Error_Invalid_UrlInputs */

const en_site_url_error_invalid_url = /** @type {(inputs: Site_Url_Error_Invalid_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That address is not valid.`)
};

const id_site_url_error_invalid_url = /** @type {(inputs: Site_Url_Error_Invalid_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alamat ini tidak valid.`)
};

/**
* | output |
* | --- |
* | "That address is not valid." |
*
* @param {Site_Url_Error_Invalid_UrlInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const site_url_error_invalid_url = /** @type {((inputs?: Site_Url_Error_Invalid_UrlInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_Url_Error_Invalid_UrlInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_site_url_error_invalid_url(inputs)
	return en_site_url_error_invalid_url(inputs)
});